function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1.5 0h2v32h-2zM14.715 5.115v.035a2.766 2.766 0 01-5.531 0v-.035H4.9v3.267a1.6 1.6 0 001.62 1.583h10.863A1.6 1.6 0 0019 8.382V5.115zM14.715 19.94v.035a2.766 2.766 0 01-5.531 0v-.035H4.9v3.267a1.6 1.6 0 001.62 1.583h10.863A1.6 1.6 0 0019 23.207V19.94z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0 11.965h32v2H0zM0 26.789h32v2H0zM21.411 19.259l.109.109v-.217l-.109.108zM25.31 19.127l1.352-1.352h-3.281l1.352 1.352h.577zM28.14 21.165v3.23h-5.268v-2.261l-1.352-1.352v4.965h7.972v-5.934l-1.352 1.352z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.145 15.707l-2.068 2.068-1.353 1.352-.621.621-1.082 1.081-1.081-1.081-.621-.621-.887-.887-.912.911v.217l1.352 1.351.568.569 1.581 1.581 2.475-2.474.644-.644 1.352-1.352 1.672-1.672-1.019-1.02z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.31 4.319l1.352-1.351h-3.281l1.352 1.351h.577zM28.14 6.358v3.23h-5.268V7.326L21.52 5.974v4.966h7.972V5.006L28.14 6.358z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.145.9l-2.068 2.068-1.353 1.351-.621.621-1.082 1.082L23.94 4.94l-.621-.621-.887-.887-.912.911v.217l1.352 1.352.568.568 1.581 1.582 2.475-2.474.644-.644 1.352-1.352 1.672-1.672L30.145.9z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
})));

var SvgLocationControlmin = function SvgLocationControlmin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationControlmin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LocationControl.min.5e4e3ad5.svg";
export { ForwardRef as ReactComponent };